const { REACT_APP_ENVIRONMENT, REACT_APP_PAYPAL_CLIENT_ID } = process.env;
const isProduction = REACT_APP_ENVIRONMENT === 'production';
const isDevelopment = REACT_APP_ENVIRONMENT === 'development';

const rootConfig = {
  apiBaseUrl: 'http://localhost:5001',
  paypalClientId:
    'AS36XIx0nnATgmM1pqG0rUSBO3e3oxyG5C8qU8GX4R-AuKjWdBK_vcjKeIblAvT7iV1qUuoYOcWvOuZS',
  resourceBaseUrl: 'https://dev-resource.thechamps.app',
  fcm: {
    apiKey: 'AIzaSyBV1pSyxJMi3qYQLbN7SldL_9tQvN95WNo',
    authDomain: 'dev-thechamps.firebaseapp.com',
    projectId: 'dev-thechamps',
    storageBucket: 'dev-thechamps.firebasestorage.app',
    messagingSenderId: '661968641587',
    appId: '1:661968641587:web:ba903c38a6004b8ddf0d46',
    measurementId: 'G-DKH8LBJ3VZ',
    vapidKey:
      'BFMWZEkn3W8W_TLTLsgdxSotTerMxeftyLa5QP3nwVMniBtqDwNHyc-pKxv1IySUCjtlnDXJJDVpC32j4dCMcFY',
  },
};

const prdConfig = {
  apiBaseUrl: 'https://api.thechamps.app',
  paypalClientId: REACT_APP_PAYPAL_CLIENT_ID,
  resourceBaseUrl: 'https://resource.thechamps.app',
  fcm: {
    apiKey: 'AIzaSyB_IuVXSGT_F7EpAqVe9kaVTVWXPntvebY',
    authDomain: 'thechamps-6834a.firebaseapp.com',
    projectId: 'thechamps-6834a',
    storageBucket: 'thechamps-6834a.firebasestorage.app',
    messagingSenderId: '256495399910',
    appId: '1:256495399910:web:bbf33ee32b9f96f9b6dc27',
    measurementId: 'G-3Z47WNJKPZ',
    vapidKey:
      'BOkpLQqKMJX-ZX6mfybmWPLUTRyU4VqihxZd7dnuKutj9qvZrguJlN7kKdhNDWwZQyAX_KDjZdUTBTR7UTdqxSA',
  },
};

const devConfig = {
  apiBaseUrl: 'https://dev-api.thechamps.app',
  resourceBaseUrl: 'https://dev-resource.thechamps.app',
  fcm: {
    apiKey: 'AIzaSyBV1pSyxJMi3qYQLbN7SldL_9tQvN95WNo',
    authDomain: 'dev-thechamps.firebaseapp.com',
    projectId: 'dev-thechamps',
    storageBucket: 'dev-thechamps.firebasestorage.app',
    messagingSenderId: '661968641587',
    appId: '1:661968641587:web:ba903c38a6004b8ddf0d46',
    measurementId: 'G-DKH8LBJ3VZ',
    vapidKey:
      'BFMWZEkn3W8W_TLTLsgdxSotTerMxeftyLa5QP3nwVMniBtqDwNHyc-pKxv1IySUCjtlnDXJJDVpC32j4dCMcFY',
  },
};

const config = Object.assign(
  rootConfig,
  isProduction ? prdConfig : isDevelopment ? devConfig : {}
);

export default config;
